import { Typography } from "@shared/ui.primitives";
import React from "react";

import type { ProductCardDataType } from "./types";

type Props = {
  product: Pick<ProductCardDataType, "brandName">;
  textOverflow?: "clip" | "ellipsis" | "fade" | "initial" | "inherit" | "unset";
};

export const HorizontalProductCardBrandName: React.FC<Props> = ({
  product,
  textOverflow
}) => {
  if (!product?.brandName) return null;
  return (
    <Typography
      variant="franchise-sm"
      colour="primary-dark"
      overflow={textOverflow}
      whiteSpace="nowrap"
    >
      {/* Non-breaking space to maintain layout height when no brand name */}
      {product?.brandName || "\u00A0"}
    </Typography>
  );
};
